import { useRealChainIdWarning } from 'hooks/useRealChainId'
import { myCustomTheme } from '../config/rainbowkit-theme'
import dynamic from 'next/dynamic'
const FullApp = dynamic(() => import('@components/FullApp'))
const RainbowKitProvider = dynamic(
  () =>
    import('@rainbow-me/rainbowkit').then(
      (module) => module.RainbowKitProvider,
    ),
  { ssr: false },
)

const FullAppWrapper = (p: any) => {
  useRealChainIdWarning()
  return (
    <>
      <RainbowKitProvider theme={myCustomTheme}>
        <FullApp Component={p.Component} pageProps={p.pageProps} />
      </RainbowKitProvider>
    </>
  )
}

export default FullAppWrapper
